<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->
<div class="col-md-12">
  <fieldset>
    <legend class="row">
      <div class="col-md-6 m-auto">Accepted Credit Cards</div>
      <div class="col-md-6">
        <button
          class="btn btn-primary float-right"
          *ngIf="
            merchant.accountDetails.worldPayAccountDetails
              .backingWPMerchantExists &&
            isUserBase() &&
            isWorldPay() &&
            isMerchantActive() &&
            !editable
          "
          (click)="setEditable(true)"
        >
          <span>
            <fa-icon [icon]="faEditPencil"></fa-icon>
          </span>
          Edit Accepted Cards
        </button>
      </div>
    </legend>

    <app-accepted-credit-cards
      *ngIf="!editable"
      [merchant]="merchant"
    ></app-accepted-credit-cards>

    <div class="mt-3" *ngIf="editable">
      <form
        name="generalInfoFormControl"
        class="form-horizontal"
        novalidate
        [formGroup]="wpAcceptedCardsForm"
        (submit)="updateElementMerchant()"
      >
        <app-accepted-credit-cards-edit
          [parentGroup]="wpAcceptedCardsForm"
          [acceptedCards]="this.acceptedCardsFormGroup"
          [merchant]="merchant"
          [isEditable]="true"
        >
        </app-accepted-credit-cards-edit>
        <app-edit-buttons
          [buttonName]="buttonName"
          [actionInProgress]="actionInProgress"
          [formInvalid]="acceptedCardsFormGroup.invalid"
          (editableEvent)="receiveEditEvent($event)"
        ></app-edit-buttons>
      </form>
    </div>
  </fieldset>
</div>
